import type { ConfigurableServer } from '@festina-life/core'

import { DetailsPanel } from '../detailsPanel/DetailsPanel'
import { ServerDetailsTabs } from './ServerDetailsTabs'

type Props = {
  server: ConfigurableServer
  onClose: () => void
}

export const ServerDetailsPanel = ({ server, onClose }: Props) => (
  <DetailsPanel
    onClose={onClose}
    header={<span className="text-gray-500 dark:text-gray-400">{server}</span>}
  >
    <ServerDetailsTabs server={server} />
  </DetailsPanel>
)
